import { NLForLinkerGridDashboard } from "src/app/components";
import Pacman from "src/app/components/layout/Pacman";
import { useSiteManagerStats } from "src/app/hooks";

const NLGridLinkerDashboardContainer = () => {
    const { siteManagerStats, loading } = useSiteManagerStats("netlinking");
    return (
        <div className="d-flex w-100 h-100 justify-content-center">
            {loading ? (
                <Pacman />
            ) : (
                <NLForLinkerGridDashboard siteHasManagerNetlinkingStats={siteManagerStats} />
            )}
        </div>
    );
};

export default NLGridLinkerDashboardContainer;
